import { ValueUtil } from "../Value/ValueUtil";
import { MessageStore } from "../../../store/MessageStore";
export var FormUtil;
(function (FormUtil) {
    const requireCheckElementArray = [];
    requireCheckElementArray.push('input[required]');
    requireCheckElementArray.push('select[required]');
    requireCheckElementArray.push('textarea[required]');
    function isSafeRequire(formElement, isShowErrorMessage = false) {
        const requireInputElements = formElement.querySelectorAll('[required]');
        for (let requireInputElement of requireInputElements) {
            let value = requireInputElement.value;
            if (ValueUtil.isEmpty(value)) {
                if (requireInputElement.hasAttribute('value')) {
                    value = requireInputElement.getAttribute('value');
                }
            }
            if (ValueUtil.isEmpty(value)) {
                if (isShowErrorMessage) {
                    const valueName = requireInputElement.getAttribute('data-value-name');
                    let errorMessage = null;
                    if (valueName != null) {
                        errorMessage = `${valueName} は必須入力です`;
                    }
                    else {
                        errorMessage = '必須項目が入力されていません';
                    }
                    const confirmMessageData = new MessageStore.ConfirmMessageData(errorMessage, () => {
                        requireInputElement.focus();
                    });
                    confirmMessageData.type = MessageStore.ConfirmMessageType.warning;
                    MessageStore.confirmMessage.set(confirmMessageData);
                }
                return false;
            }
        }
        return true;
    }
    FormUtil.isSafeRequire = isSafeRequire;
})(FormUtil || (FormUtil = {}));
